import tfbankCard from '@/assets/tfbank-card.jpg';
import rememberCard from '@/assets/remember-card.svg';
import instabankCard from '@/assets/instabank-card.jpg';
import norwegianCard from '@/assets/norwegian-card.svg';
import morrowCard from '@/assets/morrow-card.jpg';

export interface QuizAnswer {
  question1?: string;
  question2?: string;
  question3?: string;
}

export interface CreditCard {
  name: string;
  description: string;
  benefits: string[];
  applyUrl: string;
  imageUrl: string;
  interestExample: string;
}

export const creditCards: Record<string, CreditCard> = {
  tfbank: {
    name: "TF Bank Mastercard",
    description: "Fleksibel bruk og gode vilkår",
    benefits: ["Ingen årsavgift", "Høy kredittgrense", "Inntil 43 dager rentefritt"],
    applyUrl: "#",
    imageUrl: tfbankCard,
    interestExample: "Eff. rente 26,69 %, kr 25.000/12 mnd. Kostnad: 3.337 kr. Totalt: 28.337 kr."
  },
  remember: {
    name: "re:member black",
    description: "God på rabatter ved netthandel",
    benefits: ["Rabatt på netthandel", "Ingen årsavgift", "Reiseforsikring inkludert"],
    applyUrl: "#",
    imageUrl: rememberCard,
    interestExample: "Eff. rente 30,33 %, kr 15.000/12 mnd. Kostnad: 1.717 kr. Totalt: 16.717 kr."
  },
  instabank: {
    name: "Instabank Mastercard",
    description: "Lav rente og ingen årsavgift",
    benefits: ["Lav rente", "Ingen årsavgift", "0 rentefrie dager"],
    applyUrl: "#",
    imageUrl: instabankCard,
    interestExample: "Eff. rente 22,85%, 45 000 kr, o/1 år, kostnad: 5 219 kr, totalt: 50 219 kr"
  },
  norwegian: {
    name: "Bank Norwegian",
    description: "Sterkt på reise, cashback og forsikring",
    benefits: ["CashPoints eller cashback på kjøp", "Reiseforsikring inkludert", "Ingen årsavgift"],
    applyUrl: "#",
    imageUrl: norwegianCard,
    interestExample: "Eff. rente 24,4 %, kr 15.000/12 mnd. Kostnad: 1.849 kr. Totalt: 16.849 kr."
  },
  morrow: {
    name: "Morrow Bank Mastercard",
    description: "Lang rentefri periode",
    benefits: ["Inntil 50 dager rentefritt", "100 % gebyrfritt", "Mobilbetaling"],
    applyUrl: "#",
    imageUrl: morrowCard,
    interestExample: "Eff. rente 28,77 %, kr 12.000/12 mnd. Kostnad: 1.726 kr. Totalt: 13.726 kr."
  }
};

export const getRecommendation = (answers: QuizAnswer): { primary: CreditCard; secondary: CreditCard } => {
  const { question1, question2, question3 } = answers;
  
  // 1. Norwegian Bank (primær) hvis bruker velger "reise" på spørsmål 2 OG ("cashback" eller "forsikring") på spørsmål 1
  if (question2 === "reise" && (question1 === "cashback" || question1 === "forsikring")) {
    return { primary: creditCards.norwegian, secondary: creditCards.tfbank };
  }
  
  // 2. Instabank (primær) hvis bruker velger "lav-rente" på spørsmål 1 OG "Betaler ofte ned over tid" på spørsmål 3
  if (question1 === "lav-rente" && question3 === "over-tid") {
    return { primary: creditCards.instabank, secondary: creditCards.tfbank };
  }
  
  // 3. re:member (primær) hvis bruker velger "rabatter" på spørsmål 1 OG "netthandel" på spørsmål 2
  if (question1 === "rabatter" && question2 === "netthandel") {
    return { primary: creditCards.remember, secondary: creditCards.tfbank };
  }
  
  // 4. Morrow Bank (primær) hvis bruker velger "lang-periode" på spørsmål 1
  if (question1 === "lang-periode") {
    return { primary: creditCards.morrow, secondary: creditCards.tfbank };
  }
  
  // 5. TF bank (primær) + re:member (sekundær) hvis bruker velger "Høy kredittgrense" på spørsmål 1
  if (question1 === "hoy-grense") {
    return { primary: creditCards.tfbank, secondary: creditCards.remember };
  }
  
  // 6. Standard anbefaling: TF Bank (primær) og Norwegian Bank (sekundær)
  return { primary: creditCards.tfbank, secondary: creditCards.norwegian };
};